import {
  HomeOutlined,
  ProfileOutlined,
  TagOutlined,
  AccountBookOutlined,
  CodeOutlined,
  BankOutlined,
  TeamOutlined,
  CameraOutlined,
  SettingOutlined,
  PictureOutlined,
  StarOutlined,
  UserOutlined,
  MoneyCollectOutlined,
  VideoCameraOutlined,
  GiftOutlined,
  FileTextOutlined,
  ToolOutlined,
  CarOutlined,
  IdcardOutlined,
  SafetyOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

export const sideMenus = [
  {
    key: "/main",
    icon: <HomeOutlined />,
    label: "main.sideMenus.home",
    permissions: {
      hideForSoleLotteryWeapp: false,
    },
  },
  {
    key: "/main/statistics",
    icon: <BarChartOutlined />,
    label: "main.sideMenus.statistics",
    permissions: {
      hideForBdShop: true,
    },
    children: [
      {
        key: "/main/statistics/overview",
        label: "main.sideMenus.statisticsOverview",
      },
      {
        key: "/main/statistics/orders",
        label: "main.sideMenus.statisticsOrders",
        permissions: {
          requiresProduct: true,
        },
      },
      {
        key: "/main/statistics/products",
        label: "main.sideMenus.statisticsProducts",
        permissions: {
          requiresProduct: true,
        },
      },
      {
        key: "/main/statistics/commissions",
        label: "main.sideMenus.statisticsCommissions",
        permissions: {
          requiresAgents: true,
        },
      },
      {
        key: "/main/statistics/transfers",
        label: "main.sideMenus.statisticsTransfers",
        permissions: {
          requiresNewWechatTransfer: true,
        },
      },
    ],
  },
  {
    key: "/main/groupon",
    icon: <TagOutlined />,
    label: "main.sideMenus.groupon",
    permissions: {
      onlyForGrouponMerchant: true,
    },
    children: [
      {
        key: "/main/groupon/deals",
        label: "main.sideMenus.grouponDeals",
        contains: ["/main/groupon/deals/edit"],
      },
      {
        key: "/main/groupon/orders",
        label: "main.sideMenus.grouponOrders",
        contains: ["/main/groupon/orders/"],
      },
    ],
  },
  {
    key: "/main/order",
    icon: <ProfileOutlined />,
    label: "main.sideMenus.order",
    permissions: {
      hideForBdShop: true,
      hideForGrouponMerchant: true,
      hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
      requiresProduct: true,
    },
    children: [
      {
        key: "/main/order/list",
        icon: null,
        label: "main.sideMenus.orderList",
      },
      {
        key: "/main/order/print-templates",
        icon: null,
        label: "main.sideMenus.printTemplates",
        contains: ["/main/order/print-templates/edit"],
      },
      {
        key: "/main/order/refund-list",
        icon: null,
        label: "main.sideMenus.refundList",
      },
      {
        key: "/main/order/download",
        icon: null,
        label: "main.sideMenus.downloadList",
        permissions: {
          hideForBdShop: true,
          hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
          requiresWeapp: true,
        },
      },
      {
        key: "/main/order/import",
        icon: null,
        label: "main.sideMenus.import",
        permissions: {
          hideForBdShop: true,
          hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
          requiresWeapp: true,
        },
      },
    ],
  },
  {
    key: "/main/delivery",
    icon: <CarOutlined />,
    label: "main.sideMenus.delivery",
    permissions: {
      requiresLbsShopOrWholesale: true,
      hideForBdShop: true,
      hideForGrouponMerchant: true,
    },
    children: [      {
        key: "/main/delivery/deliveryman",
        icon: null,
        label: "deliveryman.title",
      },
      {
        key: "/main/delivery/community",
        icon: null,
        label: "community.title",
        permissions: {
          requiresMerchantCuratedPoi: true,
        },
      },
      {
        key: "/main/delivery/zones",
        icon: null,
        label: "deliveryZone.title",
        permissions: {
          requiresSaasLbsShopOrWholesale: true,
        },
      },
      {
        key: "/main/delivery/location",
        icon: null,
        label: "merchantLocation.title",
      },
    ],
  },
  {
    key: "/main/product",
    icon: <TagOutlined />,
    label: "main.sideMenus.product",
    permissions: {
      hideForSoleLotteryWeapp: true,
      hideForGrouponMerchant: true,
      requiresProduct: true,

    },
    children: [
      {
        key: "/main/product/list",
        icon: null,
        label: "main.sideMenus.productList",
        contains: ["/main/product/edit"],
      },
      {
        key: "/main/product/units",
        icon: null,
        label: "main.sideMenus.productUnits",
        permissions: {
          requiresMultiUnit: true,
        },
      },
      {
        key: "/main/product/import",
        icon: null,
        label: "main.sideMenus.productImport",
      },
    ],
  },
  {
    key: "/main/manage-ads",
    icon: <StarOutlined />,
    label: "main.sideMenus.manageAds",
    permissions: {
      hideForBdShop: true,
      hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
      
    },
    children: [
      {
        key: "/main/manage-ads/ads",
        icon: null,
        label: "main.sideMenus.ads",
      },
      {
        key: "/main/manage-ads/navs",
        icon: null,
        label: "main.sideMenus.navs",
      },
      {
        key: "/main/manage-ads/popups",
        icon: null,
        label: "main.sideMenus.popups",
      },
      {
        key: "/main/manage-ads/splash",
        icon: null,
        label: "main.sideMenus.splash",
        permissions: {
          requiresWeapp: true,
        },
      },
      {
        key: "/main/manage-ads/home-ad",
        icon: null,
        label: "main.sideMenus.homeAd",
        permissions: {
          requiresWeapp: true,
        },
      },
      {
        key: "/main/manage-ads/home-product-groups",
        icon: null,
        label: "main.sideMenus.homeProductGroups",
        permissions: {
          requiresWeapp: true,
          requiresProduct: true,
        },
      },
      {
        key: "/main/manage-ads/user-center-ad",
        icon: null,
        label: "main.sideMenus.userCenterAd",
        permissions: {
          hideForBdShop: true,
        },
      },
      {
        key: "/main/manage-ads/become-agent-ad",
        icon: null,
        label: "main.sideMenus.becomeAgentAd",
        permissions: {
          requiresWeappOrNoAgents: true,
        },
      },
    ],
  },
  {
    key: "/main/sales",
    icon: <AccountBookOutlined />,
    label: "main.sideMenus.sales",
    permissions: {
      hideForBdShop: true,
      hideForGrouponMerchant: true,
    },
    children: [
      {
        key: "/main/sales/coupons",
        icon: null,
        label: "main.sideMenus.coupons",
      },
      {
        key: "/main/sales/flash",
        icon: null,
        label: "main.sideMenus.flash",
        contains: ["/main/sales/flash-edit"],
      },
      {
        key: "/main/sales/gift",
        icon: null,
        label: "main.sideMenus.gift",
        contains: ["/main/sales/gift"],
      },
      {
        key: "/main/sales/tasks",
        icon: null,
        label: "main.sideMenus.taskCenter",
        permissions: {
          requiresTaskCenter: true,
        },
      },
    ],
  },
  {
    key: "/main/lottery",
    icon: <GiftOutlined />,
    label: "main.sideMenus.lottery",
    permissions: {
      requiresLottery: true,
      hideForBdShop: true,
      hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
    },
    children: [
      {
        key: "/main/lottery/list",
        label: "main.sideMenus.lotteryList",
      },
      {
        key: "/main/lottery/theme",
        label: "main.sideMenus.lotteryTheme",
      },
      {
        key: "/main/lottery/recommender",
        label: "recommender.title",
      },
    ],
  },
  {
    key: "/main/red-packet",
    icon: <ToolOutlined />,
    label: "main.sideMenus.redPacket",
    permissions: {
      hideForBdShop: true,
      hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
      requiresLotteryQrcode: true,
    },
  },
  {
    key: "/main/lottery-qrcode",
    icon: <GiftOutlined />,
    label: "qrcode.title",
    permissions: {
      requiresLotteryQrcode: true,
      hideForBdShop: true,
    },
    children: [
      {
        key: "/main/lottery-qrcode/list",
        label: "qrcode.listTitle",
      },
      {
        key: "/main/lottery-qrcode/activity",
        label: "qrcode.activity",
      },
      {
        key: "/main/lottery-qrcode/store",
        label: "qrcode.store",
      },
      {
        key: "/main/lottery-qrcode/agreement",
        label: "qrcode.agreement",
      },
      {
        key: "/main/lottery-qrcode/redeem-order",
        label: "qrcode.redeemOrder",
      },
    ],
  },
  {
    key: "/main/article-section",
    icon: <FileTextOutlined />,
    label: "main.sideMenus.article",
    permissions: {
      requiresArticle: true,
      hideForBdShop: true,
    },
    children: [
      {
        key: "/main/article",
        label: "main.sideMenus.articleList",
      },
      {
        key: "/main/article/tags",
        label: "main.sideMenus.articleTags",
      },
      {
        key: "/main/article/editors-choice",
        label: "main.sideMenus.articleEditorsChoice",
      },
    ],
  },
  
  {
    key: "/main/mini-program",
    icon: <CodeOutlined />,
    label: "main.sideMenus.mini",
    permissions: {
      requiresWeapp: true,
      hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
    },
    children: [
      {
        key: "/main/mini-program/setting",
        icon: null,
        label: "main.sideMenus.miniSetting",
      },
    ],
  },
  {
    key: "/main/review",
    icon: <StarOutlined />,
    label: "main.sideMenus.review",
    permissions: {
      onlyForGrouponMerchant: true,
    },
    children: [
      {
        key: "/main/review/list",
        icon: null,
        label: "main.sideMenus.reviewList",
      },
    ],
  },
  {
    key: "/main/finance",
    icon: <BankOutlined />,
    label: "main.sideMenus.finance",
    permissions: {
      hideForBdShop: true,
      
    },
    children: [
      {
        key: "/main/finance/home",
        icon: null,
        label: "main.sideMenus.financeHome",
        permissions: {
          requiresBBLbsShop: true,
        },
      },
      {
        key: "/main/finance/check",
        icon: null,
        label: "main.sideMenus.financeCheck",
        contains: ["/main/finance/check-daily", "/main/finance/order-detail"],
        permissions: {
          requiresBBLbsShop: true,
        },
      },
      {
        key: "/main/finance/account",
        icon: null,
        label: "main.sideMenus.financeAccount",
        contains: ["/main/finance/bill-detail"],
        permissions: {
          requiresBBLbsShop: true,
        },
      },
      {
        key: "/main/finance/download",
        icon: null,
        label: "main.sideMenus.financeDownload",
        permissions: {
          requiresBBLbsShop: true,
        },
      },
      {
        key: "/main/finance/withdraw-list",
        icon: null,
        label: "main.sideMenus.withdrawList",
        permissions: {
          hideForBBLbsShop: true,
          requiresAgents: true,
        },
      },
      {
        key: "/main/finance/send-money-list",
        icon: null,
        label: "main.sideMenus.sendMoney",
        permissions: {
          hideForBBLbsShop: true,
          requiresAgents: true,
        },
      },
      {
        key: "/main/finance/balance-vip-orders",
        icon: null,
        label: "main.sideMenus.balanceVipOrders",
        permissions: {
          requiresBalanceVip: true,
          hideForBBLbsShop: true,
        },
      },
      {
        key: "/main/finance/special-share-list",
        icon: null,
        label: "main.sideMenus.specialShareList",
        permissions: {
          hideForBBLbsShop: true,
          requiresAgentsOrSpecialShare: true,
        },
      },
      {
        key: "/main/finance/transfer-accounts",
        icon: null,
        label: "main.sideMenus.transferAccountList",
        permissions: {
          hideForBBLbsShop: true,
          requiresNewWechatTransfer: true,
        },
      },
      {
        key: "/main/finance/red-packet-topups",
        icon: null,
        label: "main.sideMenus.wechatRedPacketTopup",
        permissions: {
          hideForBBLbsShop: true,
          requiresNewWechatTransfer: true,
        },
      },
      {
        key: "/main/finance/withdraw-request-list",
        icon: null,
        label: "main.sideMenus.withdrawRequestList",
        permissions: {
          hideForBBLbsShop: true,
          requiresAgents: true,
        },
      },
    ],
  },
  {
    key: "/main/members",
    icon: <IdcardOutlined />,
    label: "main.sideMenus.members",
    permissions: {
      requiresMembers: true,
      hideForBdShop: true,
    },
    children: [
      {
        key: "/main/members/list",
        icon: null,
        label: "main.sideMenus.membersList",
      },
      {
        key: "/main/members/card",
        icon: null,
        label: "main.sideMenus.membersCard",
      },
      {
        key: "/main/members/order",
        icon: null,
        label: "main.sideMenus.membersOrder",
      },
      {
        key: "/main/members/gift-codes",
        icon: null,
        label: "main.sideMenus.membersGiftCodes",
      },
    ],
  },
  {
    key: "/main/proxy",
    icon: <TeamOutlined />,
    label: "main.sideMenus.proxy",
    permissions: {
      requiresBBShopOrAgents: true,
      hideForBdShop: true,
    },
    children: [
      {
        key: "/main/proxy/list",
        icon: null,
        label: "main.sideMenus.proxyList",
      },
      {
        key: "/main/proxy/recommender-list",
        icon: null,
        label: "main.sideMenus.agentRecommenderList",
      },
      {
        key: "/main/proxy/commission-list",
        icon: null,
        label: "main.sideMenus.commissionList",
      },
      {
        key: "/main/proxy/agent-level",
        icon: null,
        label: "main.sideMenus.agentLevel",
      },

      {
        key: "/main/proxy/product-list",
        icon: null,
        label: "main.sideMenus.agentLevelProduct",
      },
    ],
  },
  {
    key: "/main/users",
    icon: <UserOutlined />,
    label: "main.sideMenus.users",
    permissions: {
      requiresWeappOrWholesaleStoreVerification: true,
      hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
    },
    children: [
      {
        key: "/main/users/list",
        icon: null,
        label: "main.sideMenus.usersList",
        permissions: {
          requiresWeapp: true,
        },
      },
      {
        key: "/main/users/store-memberships",
        icon: null,
        label: "main.sideMenus.storeMemberships",
        permissions: {
          requiresWholesaleStoreVerification: true,
        },
      },
      {
        key: "/main/users/store-memberships-attribution",
        icon: null,
        label: "main.sideMenus.storeMembershipAttribution",
        permissions: {
          requiresWholesaleStoreVerification: true,
        },
      },
    ],
  },
  {
    key: "/main/balance",
    icon: <MoneyCollectOutlined />,
    label: "main.sideMenus.balance",
    permissions: {
      requiresBBShopOrAgents: true,
      hideForBdShop: true,
    },
    children: [
      {
        key: "/main/balance/topup",
        icon: null,
        label: "main.sideMenus.topup",
      },
      {
        key: "/main/balance/spend",
        icon: null,
        label: "main.sideMenus.spend",
      },
      {
        key: "/main/balance/reduce",
        icon: null,
        label: "main.sideMenus.reduce",
      },
      {
        key: "/main/balance/list",
        icon: null,
        label: "main.sideMenus.balanceUserList",
      },
    ],
  },
  {
    key: "/main/shows",
    icon: <CameraOutlined />,
    label: "main.sideMenus.shows",
    permissions: {
      requiresBBShopOrAgents: true,
      hideForBdShop: true,
      requiresShops: true
    },
    children: [
      {
        key: "/main/shows/list",
        label: "main.sideMenus.showsList",
      },
    ],
  },
  {
    key: "/main/weapp-management",
    icon: <ToolOutlined />,
    label: "main.sideMenus.manageWeapp",
    permissions: {
      requiresBBShopMerchant: true,
    },
  },
  {
    key: "/main/shop",
    icon: <ToolOutlined />,
    label: "tuangou.shop",
    permissions: {
      hideForBdShop: true,
      requiresShops: true,

    },
    children: [
      {
        key: "/main/shop/list",
        icon: null,
        label: "tuangou.shop",
      },
      {
        key: "/main/shop/slider-ads",
        icon: null,
        label: "tuangou.sliderAd.title",
      },
    ],
  },

  {
    key: "/main/media",
    icon: <PictureOutlined />,
    label: "main.sideMenus.media",
    permissions: {
      hideForBdShop: true,
      hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
      
    },
    children: [
      {
        key: "/main/media/files",
        icon: null,
        label: "main.sideMenus.media",
      },

      {
        key: "/main/media/storage-setting",
        icon: null,
        label: "main.sideMenus.storageSetting",
        permissions: {
          requiresWeapp: true,
        },
      },
    ],
  },

  {
    key: "/main/course",
    icon: <PictureOutlined />,
    label: "course.otherTitle",
    permissions: {
      requiresCourse: true,
      hideForBdShop: true,
    },
    children: [
      {
        key: "/main/course/teachers",
        icon: null,
        label: "course.teacher.title",
      },
      {
        key: "/main/course/slider-ads",
        icon: null,
        label: "course.sliderAd.title",
      },
      {
        key: "/main/course/categories",
        icon: null,
        label: "course.category.title",
      },
      {
        key: "/main/course/orders",
        icon: null,
        label: "course.order.title",
      },
    ],
  },
  {
    key: "/main/courses",
    icon: <PictureOutlined />,
    label: "course.title",
    permissions: {
      requiresCourse: true,
      hideForBdShop: true,
    },
    children: [
      {
        key: "/main/courses/article-courses",
        icon: null,
        label: "course.titleArticle",
      },
      {
        key: "/main/courses/audio-courses",
        icon: null,
        label: "course.titleAudio",
      },
      {
        key: "/main/courses/video-courses",
        icon: null,
        label: "course.titleVideo",
      },
      {
        key: "/main/courses/albums",
        icon: null,
        label: "course.album.title",
      },
    ],
  },
  {
    key: "video-submenu",
    icon: <VideoCameraOutlined />,
    label: "video.title",
    permissions: {
      hideForBdShop: true,
      requiresVideo: true,
    },
    children: [
      {
        key: "/main/videos",
        icon: null,
        label: "video.submenuVideos",
      },
      {
        key: "/main/videos/categories",
        icon: null,
        label: "video.category.title",
      },
    ],
  },
  {
    key: "/main/custom-pages",
    icon: <FileTextOutlined />,
    label: "customPage.title",
    contains: ["/main/custom-pages/create", "/main/custom-pages/edit"],
    permissions: {
      hideForBdShop: true,
      requiresCustomPage: true,
    },
  },
  {
    key: "/main/bd",
    icon: <PictureOutlined />,
    label: "bd.employee.title",
    permissions: {
      onlyForBdShop: true, // Only show for BD shops
    },
    children: [
      {
        key: "/main/bd/employees",
        icon: null,
        label: "bd.employee.title",
      },
    ],
  },
  {
    key: "/main/admin",
    icon: <SafetyOutlined />,
    label: "main.sideMenus.adminSection",
    permissions: {
      requiresSuperAdmin: true,
    },
    children: [
      {
        key: "/main/admin/order-debug",
        icon: null,
        label: "main.sideMenus.orderDebug",
      },
      {
        key: "/main/admin/profit-sharing-reconciliation",
        icon: null,
        label: "main.sideMenus.profitSharingReconciliation",
      },
      {
        key: "/main/admin/weapp",
        icon: null,
        label: "main.sideMenus.orderDebug",
      },
    ],
  },
  {
    key: "/main/setting",
    icon: <SettingOutlined />,
    label: "main.sideMenus.setting",
    permissions: {
      hideForBdShop: true,
      hideForSoleLotteryWeapp: false, // Show for sole lottery weapp
    },
    children: [
      {
        key: "/main/setting/shop",
        icon: null,
        label: "main.sideMenus.settingShop",
      },
      {
        key: "/main/setting/appearance",
        icon: null,
        label: "appearance.title",
        permissions: {
          requiresSaasShop: true,
        },
      },
      {
        key: "/main/setting/lang",
        icon: null,
        label: "main.sideMenus.selectLang",
      },
      {
        key: "/main/setting/merchant-info-setting",
        icon: null,
        label: "main.sideMenus.merchantSetting",
      },
      {
        key: "/main/setting/staff",
        icon: null,
        label: "main.sideMenus.merchantStaff",
      },
      {
        key: "/main/setting/applyment-info",
        icon: null,
        label: "main.sideMenus.wechatMerchantApplymentInfo",
      },
    ],
  },
];
